import React from 'react';

export interface ChipOption {
  value: string;
  label: string;
}

interface ChipsProps {
  options: ChipOption[];
  selected: string[];
  onToggle: (value: string) => void;
  /** `single` usa `radiogroup`; `multiple`, `group`. Cambia la semántica para el lector. */
  mode: 'single' | 'multiple';
  label: string;
}

/**
 * Grupo de chips de selección. Reemplaza al `<select>` de categoría.
 *
 * Los chips son `button` y no `input` para poder darles la forma que pide la
 * especificación, así que la semántica va por `role` y `aria-checked`.
 */
export const Chips: React.FC<ChipsProps> = ({
  options,
  selected,
  onToggle,
  mode,
  label,
}) => (
  <div
    className="bk-chips"
    role={mode === 'single' ? 'radiogroup' : 'group'}
    aria-label={label}
  >
    {options.map((option) => {
      const isActive = selected.includes(option.value);

      return (
        <button
          key={option.value}
          type="button"
          role={mode === 'single' ? 'radio' : 'checkbox'}
          aria-checked={isActive}
          className={`bk-chip${isActive ? ' bk-chip--active' : ''}`}
          onClick={() => onToggle(option.value)}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
